import { useMemo } from 'react';
import { POSTULATION_STATUS } from '../constants/postulations.ts';
import type { PostulationStatus } from '../constants/postulations.ts';

export interface Postulation {
  id: number;
  status: PostulationStatus;
  user: {
    id: number;
    name: string;
    last_name: string;
    type: string;
    razon_social?: string;
    image_profile: string;
    profession?: string;
  };
}

export interface FilteredPostulations {
  received: Postulation[];
  accepted: Postulation[];
  denied: Postulation[];
  counts: {
    received: number;
    accepted: number;
    denied: number;
    total: number;
  };
}

export const usePostulationsFilter = (postulaciones: Postulation[] = []): FilteredPostulations => {
  const filtered = useMemo(() => {
    const received = postulaciones.filter(
      (postulation) => postulation.status === POSTULATION_STATUS.SEND
    );
    const accepted = postulaciones.filter(
      (postulation) => postulation.status === POSTULATION_STATUS.ALLOWED
    );
    const denied = postulaciones.filter(
      (postulation) => 
        postulation.status === POSTULATION_STATUS.DENIED || 
        postulation.status === POSTULATION_STATUS.NEGATED
    );

    return {
      received,
      accepted,
      denied,
      counts: {
        received: received.length,
        accepted: accepted.length,
        denied: denied.length,
        total: postulaciones.length
      }
    };
  }, [postulaciones]);

  return filtered;
};

